<template>
    <div>
      <Warning v-if="computeTotalPropValue > 100000"/> 
        <template v-if="paymentStep === 1">
            <FormHeading
                >Confirm {{
                    propertyValueOverLimit
                        ? "Requested Coverage"
                        : "Coverage"
                }}</FormHeading
            >
            <div class="table-wrapper table-bind">
                <div class="table-header">
                    <h3>Covered Property</h3>
                    <h3 class="right-align">Limit of Insurance</h3>
                </div>

                <div
                    v-for="(item, index) in properties"
                    :key="index"
                    class="table-row"
                >
                    <div class="cell">
                        <div class="row-label">
                            <span v-if="item.year">
                                {{ item.year }}
                            </span>
                            <span>{{ item.description }}</span>
                            <div class="row-bottom">
                                <p v-if="item.serial">{{ item.serial }}</p>
                            </div>
                        </div>
                        <template v-if="item.lien">
                            <div class="lien-info">
                                <p class="heading">
                                    Lienholder:
                                    <span class="details">{{
                                        item.lien.name +
                                            " - " +
                                            formatLienAddress(item.lien)
                                    }}</span>
                                </p>
                            </div>
                        </template>
                    </div>
                    <div class="cell">
                        <p class="row-label right-align">
                            ${{ addComma(item.value) }}
                        </p>
                    </div>
                </div>
                <div class="table-footer">
                    <div class="cell">
                        <p class="row-label total-text">
                            Total Property Limit of Insurance
                        </p>
                    </div>
                    <div class="cell">
                        <p class="row-label total right-align">
                            ${{ totalPropertiesValue }}
                        </p>
                    </div>
                    <template v-if="computeTotalPropValue <= 100000">
                        <div class="cell">
                            <p class="row-label total-text">Deductible</p>
                        </div>
                        <div class="cell">
                            <p class="row-label total right-align">
                                ${{ totalDeductible }}
                            </p>
                        </div>
                    </template>
                </div>
                <template v-if="computeTotalPropValue <= 100000">
                    <div class="table-header">
                        <h3>Premium</h3>
                        <h3 class="right-align">Amount</h3>
                    </div>
                    <div class="table-row">
                        <div class="cell">
                            <p class="row-label">
                                Premium for Covered Property
                            </p>
                        </div>
                        <div class="cell">
                            <p class="row-label right-align">
                                ${{ round(totalYearlyPremium) }}
                            </p>
                        </div>
                    </div>
                    <template v-if="availTria === true">
                        <div class="table-row">
                            <div class="cell">
                                <p class="row-label">Premium for TRIA</p>
                            </div>
                            <div class="cell">
                                <p class="row-label right-align">
                                    ${{ round(this.triaItem.triaPremium) }}
                                </p>
                            </div>
                        </div>
                    </template>
                    <div class="table-footer">
                        <div class="cell">
                            <p class="row-label total-text">
                                Total Annual Premium
                            </p>
                        </div>
                        <div class="cell">
                            <p
                                v-if="availTria === true"
                                class="row-label total right-align"
                            >
                                ${{ round(annualPremium) }}
                            </p>
                            <p v-else class="row-label total right-align">
                                ${{ round(totalYearlyPremium) }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>

            <FormInputLabel
                >{{ propertyValueOverLimit ? "Requested " : "" }}Policy
                Effective Date</FormInputLabel
            >
            <FormGroup class="form-group-dates">
                <el-date-picker
                    v-model="policyEffectiveDate"
                    type="date"
                    placeholder="Pick a Date"
                    format="MMMM d, yyyy"
                    valueFormat="yyyy-MM-dd"
                    clear-icon="el-icon-close"
                    ref="policyEffectiveDate"
                    @change="effectiveDateChange"
                ></el-date-picker>
                <p
                    class="expiration-date"
                    v-show="!this.beforeCurrentDate && this.policyEffectiveDate"
                >
                    Expires on {{ policyExpirationDate }}
                </p>
            </FormGroup>
            <p class="error" v-if="errors.policyEffectiveDate.length">
                {{ errors.policyEffectiveDate }}
            </p>

            <FormInputLabel class="heading-spacer"
                >Fraud Statement</FormInputLabel
            >
            <P
                >It is a crime to knowingly provide false, incomplete or
                misleading information to an insurance company for the purpose
                of defrauding the company. Penalties may include imprisonment,
                fines or a denial of insurance benefits.
            </P>
            <P
                >For New York residents: Any person who knowingly and with
                intent to defraud any insurance company or other person files an
                application for insurance or statement of claim containing any
                materially false information, or conceals for the purpose of
                misleading, information concerning any fact material thereto,
                commits a fraudulent insurance act, which is a crime, and shall
                also be subject to a civil penalty not to exceed five thousand
                dollars and the stated value of the claim for each such
                violation.</P
            >
            <CheckboxButtons
                :value="policy_agree"
                :name="''"
                label
                @change="handlePolicyAgreeChange"
                :items="policyAgreeOptions"
                :error="errors['policy_agree']"
                class="secondary"
            />

            <div class="button-group">
                <Button class="transparent" @click="prev" v-if="!loading"
                    >Back</Button
                >
                <Button class="red" @click="checkForm(1)" :loading="loading"
                    >Continue</Button
                >
            </div>
        </template>
        <template v-if="paymentStep === 2">
            <FormHeading>Billing details</FormHeading>
            <template v-if="computeTotalPropValue <= 100000">
                <div class="table-row">
                    <div class="cell">
                        <p class="row-label">Premium for Covered Property</p>
                    </div>
                    <div class="cell">
                        <p class="row-label right-align">
                            ${{ round(totalYearlyPremium) }}
                        </p>
                    </div>
                </div>
                <template v-if="availTria === true">
                    <div class="table-row">
                        <div class="cell">
                            <p class="row-label">Premium for TRIA</p>
                        </div>
                        <div class="cell">
                            <p class="row-label right-align">
                                ${{ round(this.triaItem.triaPremium) }}
                            </p>
                        </div>
                    </div>
                </template>
                <div class="table-footer">
                    <div class="cell">
                        <p class="row-label total-text">Total Annual Premium</p>
                    </div>
                    <div class="cell">
                        <p
                            v-if="availTria === true"
                            class="row-label total right-align"
                        >
                            ${{ round(annualPremium) }}
                        </p>
                        <p v-else class="row-label total right-align">
                            ${{ round(totalYearlyPremium) }}
                        </p>
                    </div>
                </div>
            </template>

            <FormInputLabel class="radio-check-heading"
                >Billing Information</FormInputLabel
            >
            <div class="checkbox-group">
                <CheckboxButtons
                    :value="payer_same_as_owner"
                    name="payer_same_as_owner"
                    label
                    @change="handlePayerOwnerChange"
                    :items="payerSameAsOwnerOptions"
                />
                <CheckboxButtons
                    v-if="!payer_same_as_owner.length > 0"
                    :value="payer_is_entity"
                    name="payer_is_entity"
                    label
                    @change="handlePayerEntityChange"
                    :items="payerEntityOptions"
                />
            </div>
            <FormGroup v-if="!payer_is_entity.length">
                <TextInput
                    v-model="payerFirstName"
                    name="payerFirstName"
                    label="First Name"
                    type="text"
                    :error="errors['payerFirstName']"
                    @input="
                        removeErrorMessage('payerFirstName', $event),
                            removeCheckBox()
                    "
                ></TextInput>
                <TextInput
                    v-model="payerLastName"
                    name="payerLastName"
                    label="Last Name"
                    type="text"
                    :error="errors['payerLastName']"
                    @input="
                        removeErrorMessage('payerLastName', $event),
                            removeCheckBox()
                    "
                ></TextInput>
            </FormGroup>
            <FormGroup
                v-if="
                    payer_is_entity.length ||
                        (payer_same_as_owner.length &&
                            this.propertyOwner.isCommercial === 1)
                "
                style="--form-input-count: 2"
            >
                <TextInput
                    v-model="payerEntityName"
                    name="payerEntityName"
                    label="Company Name"
                    type="text"
                    :error="errors['payerEntityName']"
                    @input="
                        removeErrorMessage('payerEntityName', $event),
                            removeCheckBox()
                    "
                ></TextInput>
            </FormGroup>

            <FormInputLabel>Billing Contact</FormInputLabel>
            <FormGroup
                v-if="payer_is_entity.length"
                style="--form-input-count: 2"
            >
                <TextInput
                    v-model="payerContactFirstName"
                    name="payerContactFirstName"
                    label="First Name"
                    type="text"
                    :error="errors['payerContactFirstName']"
                    @input="
                        removeErrorMessage('payerContactFirstName', $event),
                            removeCheckBox()
                    "
                ></TextInput>
                <TextInput
                    v-model="payerContactLastName"
                    name="payerContactLastName"
                    label="Last Name"
                    type="text"
                    :error="errors['payerContactLastName']"
                    @input="
                        removeErrorMessage('payerContactLastName', $event),
                            removeCheckBox()
                    "
                ></TextInput>
            </FormGroup>
            <FormGroup style="--form-input-count: 2">
                <TextInput
                    v-model="payerEmail"
                    name="payerEmail"
                    label="Email"
                    type="text"
                    :error="errors['payerEmail']"
                    @input="
                        removeErrorMessage('payerEmail', $event),
                            removeCheckBox()
                    "
                ></TextInput>
                <Phone
                    v-model="payerPhone"
                    name="payerPhone"
                    label="Phone"
                    type="text"
                    :error="errors['payerPhone']"
                    @input="
                        removeErrorMessage('payerPhone', $event),
                            removeCheckBox()
                    "
                ></Phone>
            </FormGroup>

            <FormInputLabel>Billing Address</FormInputLabel>
            <div class="form-group fg-map" @keydown.enter.prevent>
                <SearchAddress :formName="'payer'" @get-address="getAddress" />
            </div>
            <FormGroup>
                <TextInput
                    v-model="streetNumber"
                    name="streetNumber"
                    label="Street Number & Name"
                    type="text"
                    :error="errors['streetNumber']"
                    @input="
                        removeErrorMessage('streetNumber', $event),
                            removeCheckBox()
                    "
                />
                <TextInput
                    v-model="unitNumber"
                    name="unitNumber"
                    label="Apt./Unit Number"
                    type="text"
                    @input="removeCheckBox()"
                />
            </FormGroup>
            <FormGroup style="--form-input-count: 3">
                <TextInput
                    v-model="city"
                    name="city"
                    label="City"
                    type="text"
                    :error="errors['city']"
                    @input="
                        removeErrorMessage('city', $event), removeCheckBox()
                    "
                />
                <Suggest
                    v-model="state"
                    name="state"
                    label="State"
                    :items="states"
                    titleField="display"
                    :hasFocus="true"
                    @change="handleStateChange"
                    :error="errors['state']"
                />
                <TextInput
                    v-model="zipCode"
                    name="zipCode"
                    label="Zip Code"
                    type="number"
                    :error="errors['zipCode']"
                    @input="
                        removeErrorMessage('zipCode', $event), removeCheckBox()
                    "
                />
            </FormGroup>

            <div class="button-group">
                <Button
                    class="transparent"
                    @click="prevPaymentStep"
                    v-if="!loading"
                    >Back</Button
                >
                <Button class="red" @click="checkForm(2)" :loading="loading"
                    >Continue</Button
                >
            </div>
        </template>
        <template v-if="paymentStep === 3">
            <FormHeading>{{
              propertyValueOverLimit
                ? "Send to Underwriter for Review"
                : "Purchase coverage"
            }}
            </FormHeading>
            <template v-if="computeTotalPropValue <= 100000">
                <div class="table-row">
                    <div class="cell">
                        <p class="row-label">Premium for Covered Property</p>
                    </div>
                    <div class="cell">
                        <p class="row-label right-align">
                            ${{ round(totalYearlyPremium) }}
                        </p>
                    </div>
                </div>
                <template v-if="availTria === true">
                    <div class="table-row">
                        <div class="cell">
                            <p class="row-label">Premium for TRIA</p>
                        </div>
                        <div class="cell">
                            <p class="row-label right-align">
                                ${{ round(this.triaItem.triaPremium) }}
                            </p>
                        </div>
                    </div>
                </template>
                <div class="table-footer">
                    <div class="cell">
                        <p class="row-label total-text">Total Annual Premium</p>
                    </div>
                    <div class="cell">
                        <p
                            v-if="availTria === true"
                            class="row-label total right-align"
                        >
                            ${{ round(annualPremium) }}
                        </p>
                        <p v-else class="row-label total right-align">
                            ${{ round(totalYearlyPremium) }}
                        </p>
                    </div>
                </div>
            </template>

            <FormInputLabel>Bank Information</FormInputLabel>
            <p v-if="propertyValueOverLimit" class="underwriter-text">
                Your account will not be debited until you receive a response
                from the underwriter.
            </p>
            <FormGroup>
                <TextInput
                    v-model="bankName"
                    name="bankName"
                    label="Bank Name"
                    type="text"
                    @input="removeErrorMessage('bankName', $event)"
                    :error="errors['bankName']"
                />
                <TextInput
                    v-model="bankRoutingNumber"
                    name="bankRoutingNumber"
                    label="Bank Routing Number"
                    type="number"
                    @input="removeErrorMessage('bankRoutingNumber', $event)"
                    @blur="isBankRoutingFocused"
                    :error="errors['bankRoutingNumber']"
                />
            </FormGroup>
            <FormGroup>
                <TextInput
                    v-model="bankAccountNumber"
                    name="bankAccountNumber"
                    label="Bank Account Number"
                    type="text"
                    @input="
                        removeErrorMessage('bankAccountNumber', $event),
                            removeErrorMessage(
                                'confirmBankAccountNumber',
                                $event
                            )
                    "
                    :error="errors['bankAccountNumber']"
                    :accountNumber="true"
                    :class="{ hide: confirmBankAccountFocus }"
                />
                <TextInput
                    v-show="bankAccountNumber"
                    v-model="confirmBankAccountNumber"
                    name="confirmBankAccountNumber"
                    label="Confirm Bank Account Number"
                    type="text"
                    @focus="setFieldHidden()"
                    @blur="setFieldVisible()"
                    @input="
                        removeErrorMessage('confirmBankAccountNumber', $event)
                    "
                    :error="errors['confirmBankAccountNumber']"
                    :accountNumber="true"
                />
            </FormGroup>

            <FormInputLabel class="radio-check-heading"
                >Type of Account</FormInputLabel
            >
            <FormGroup>
                <RadioButtons
                    :value="accountType"
                    name="accountType"
                    label
                    :items="accountTypeOption"
                    @change="handleAccountTypeChange"
                    :error="errors['accountType']"
                    @resolve-error="errors['accountType'] = ''"
                />
            </FormGroup>

            <FormInputLabel class="radio-check-heading"
                >What payment terms would you like?</FormInputLabel
            >
            <FormGroup>
                <RadioButtons
                    :value="paymentTerms"
                    name="paymentTerms"
                    label
                    :items="paymentTermOptions"
                    @change="handlePaymentChange"
                    :error="errors['paymentTerms']"
                />
            </FormGroup>
            <P class="alternate-note terms"
                >*Based on the timing of when you buy insurance with Dremca,
                premium payments will be withdrawn in 10, 11, or 12 equal
                installments. You will receive a payment schedule from the
                carrier two weeks before the first payment is withdrawn.</P
            >

            <template v-if="paymentTerms.value === 'monthly'">
                <FormInputLabel class="radio-check-heading"
                    >When would you like payments withdrawn?</FormInputLabel
                >
                <FormGroup>
                    <RadioButtons
                        :value="paymentWithdraw"
                        name="paymentWithdraw"
                        label
                        :items="paymentWithdrawOption"
                        @change="handleWithdrawOptionChange"
                        :error="errors['paymentWithdraw']"
                        @resolve-error="errors['paymentWithdraw'] = ''"
                    />
                </FormGroup>
            </template>
            <FormInputLabel>Signature</FormInputLabel>
            <P
                >I hereby authorize and request Berkley Insurance Company
                (hereinafter called “COMPANY”), to initiate debit entries to my
                account indicated above in the bank named above (hereinafter
                called “BANK”). I authorize and request BANK to accept any debit
                entries initiated by COMPANY to this account and to debit the
                same to this account without responsibility for the correctness
                thereof.</P
            >
            <P
                >It is understood that this agreement may be terminated by me at
                any time by written notification to COMPANY or BANK. COMPANY or
                BANK shall effect termination after receipt of such notification
                and a reasonable time to act on it.</P
            >
            <CheckboxButtons
                :value="esignature_agree"
                :name="''"
                label
                @change="handleEsignatureAgreeChange"
                :items="esignatureAgreeOptions"
                :error="errors['esignature_agree']"
                class="secondary"
            />
            <TextInput
                class="signature"
                v-model="signature"
                name="signature"
                label="Full Name"
                :disabled="this.esignature_agree.length === 0"
                :error="errors['signature']"
                @input="removeErrorMessage('signature', $event)"
            ></TextInput>

            <div class="button-group">
                <Button
                    class="transparent"
                    @click="
                        prevPaymentStep();
                        prev();
                    "
                    v-if="!loading"
                    >Back</Button
                >
                <Button class="red" @click="checkForm(3)" :loading="loading">{{
                    propertyValueOverLimit ? "Send to Underwriter" : "Buy"
                }}</Button>
            </div>
        </template>
    </div>
</template>

<script>
import {
  FormHeading,
  FormInputLabel,
  Button,
  TextInput,
  FormGroup,
  RadioButtons,
  P,
  CheckboxButtons,
  Suggest,
  Phone
} from "../../style";
import Warning from "../Warning";
import { addCommaToNumber, scrollTop, formatAddress } from "../../utils";
import { STATES } from "../../utils/constants";
import SearchAddress from "./SearchAddress";
import { mapActions, mapState } from "vuex";
import { VERIFY_TOKEN } from "../../store/types";
import moment from "moment-timezone";
export default {
  name: "Payment",
  props: {
    step: {
      type: Number,
      required: true
    },
    properties: {
      type: Array,
      default: () => []
    },
    property: {
      type: Number,
      default: 1
    },
    propertyOwner: {
      type: Object,
      default: () => {}
    },
    triaItem: {
      type: Object
    },
    payment: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormHeading,
    FormInputLabel,
    Button,
    TextInput,
    FormGroup,
    RadioButtons,
    P,
    CheckboxButtons,
    Suggest,
    Phone,
    SearchAddress,
    Warning
  },
  mounted() {
    scrollTop();
    if (!this.payment.policyEffectiveDate) {
      this.currentDate();
    }
    if (this.payer_same_as_owner.length) {
      this.handleSamePropertyOwner();
    }
  },
  data() {
    return {
      bankName: "",
      bankRoutingNumber: "",
      bankAccountNumber: "",
      confirmBankAccountNumber: "",
      accountType: {},
      paymentTerms: { value: this.payment.premiumBilling },
      loading: false,
      policyEffectiveDate: "",
      dateToday: "",
      paymentStep: 1,
      policy_agree: [],
      esignature_agree: [],
      payer_same_as_owner: ["payer_same_as_owner"],
      payer_is_entity: [],
      payerFirstName: "",
      payerLastName: "",
      payerEntityName: "",
      payerContactFirstName: "",
      payerContactLastName: "",
      payerEmail: "",
      payerPhone: "",
      streetNumber: "",
      unitNumber: "",
      city: "",
      state: null,
      zipCode: "",
      paymentWithdraw: {},
      signature: "",
      emailValidator: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      errors: {
        policyEffectiveDate: "",
        policy_agree: "",
        esignature_agree: "",
        payerFirstName: "",
        payerLastName: "",
        payerEntityName: "",
        payerContactFirstName: "",
        payerContactLastName: "",
        payerEmail: "",
        payerPhone: "",
        streetNumber: "",
        city: "",
        state: "",
        zipCode: "",
        bankName: "",
        bankRoutingNumber: "",
        bankAccountNumber: "",
        confirmBankAccountNumber: "",
        accountType: "",
        paymentTerms: "",
        paymentWithdraw: "",
        signature: ""
      },
      confirmBankAccountFocus: false,
      errorFields: []
    };
  },
  watch: {
    bankRoutingNumber(value) {
      let newBankRoutingNumber = value.split("");
      if (newBankRoutingNumber.length > 9) {
        this.errors["bankRoutingNumber"] =
                    "Please enter a valid 9-digit bank routing number.";
      }
    },
    paymentStep: {
      immediate: true,
      handler() {
        scrollTop();
      }
    },
    payment: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const { bankName, bankRoutingNumber, bankAccountNumber, accountType, paymentTerms, policyEffectiveDate, paymentsWithdrawn } = newVal;
          if (bankName)
            this.bankName = bankName;
          if (bankRoutingNumber)
            this.bankRoutingNumber = bankRoutingNumber;
          if (bankAccountNumber)
            this.bankAccountNumber = bankAccountNumber;
          if (accountType)
            this.accountType = accountType;
          if (paymentTerms)
            this.paymentTerms = paymentTerms;
          if (policyEffectiveDate)
            this.policyEffectiveDate = policyEffectiveDate;
          if (paymentsWithdrawn)
            this.paymentWithdraw = paymentsWithdrawn;
        }
      }
    }
  },
  methods: {
    ...mapActions({
      verifyToken: VERIFY_TOKEN
    }),
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "homepage".
      const token = await this.$recaptcha("homepage");
      this.verifyToken({
        token
      }).then(res => {
        const { success, score } = res;
        this.$emit("set-score", score);
        if (success) {
          this.submitFormattedProperty();
          this.$emit("finalize");
        }
      });
      // Do stuff with the received token.
    },
    submitFormattedProperty() {
      let paymentData = {
        bankName: this.bankName,
        bankRoutingNumber: this.bankRoutingNumber,
        bankAccountNumber: this.bankAccountNumber,
        accountType: this.accountType.value,
        paymentTerms: this.paymentTerms.value,
        policyEffectiveDate: this.policyEffectiveDate,
        timezone: moment.tz.guess(),
        signature: this.signature
      };
      if (this.paymentTerms.value == "monthly") {
        paymentData["paymentsWithdrawn"] = this.paymentWithdraw.value;
      }
      this.$emit("format-property", paymentData);
      let billingData = {
        name: this.payer_is_entity.length
          ? this.payerEntityName
          : `${this.payerFirstName} ${this.payerLastName}`,
        isCompany: this.payer_is_entity.length == 1,
        email: this.payerEmail,
        phone: this.payerPhone,
        street: this.streetNumber,
        city: this.city,
        state: this.state.value,
        zip: this.zipCode
      };
      if (billingData.isCompany) {
        billingData["contactFirstName"] = this.payerContactFirstName;
        billingData["contactLastName"] = this.payerContactLastName;
      }
      if (this.unitNumber.trim().length) {
        billingData["unitNumber"] = this.unitNumber;
      }
      this.$emit("format-billing", billingData);
    },
    next() {
      this.$emit("next-step");
    },
    prev() {
      if (this.propertyValueOverLimit && this.paymentStep === 1) {
        this.$emit("prev-step-owner");
      } else {
        this.$emit("prev-step");
        let paymentData = {
          bankName: this.bankName,
          bankRoutingNumber: this.bankRoutingNumber,
          bankAccountNumber: this.bankAccountNumber,
          accountType: this.accountType,
          paymentTerms: this.paymentTerms,
          policyEffectiveDate: this.policyEffectiveDate,
        };
        if (this.paymentTerms.value == "monthly") {
          paymentData["paymentsWithdrawn"] = this.paymentWithdraw;
        }
        this.$emit("format-property", paymentData);
      }
    },
    getAddress($event) {
      const { placeResultData } = $event;
      let types = [];
      for (
        let i = 0;
        i < placeResultData.address_components.length;
        i++
      ) {
        let type = placeResultData.address_components[i].types[0];
        let componentForm = {
          street_number: "short_name",
          route: "long_name",
          locality: "long_name",
          administrative_area_level_1: "short_name",
          administrative_area_level_2: "short_name",
          country: "long_name",
          postal_code: "short_name"
        };
        types.push(type);

        switch (type) {
        case "street_number":
          this.streetNumber =
                            placeResultData.address_components[i][
                              componentForm[type]
                            ];
          this.removeErrorMessage(
            "streetNumber",
            this.streetNumber
          );
          break;

        case "route":
          this.streetNumber =
                            this.streetNumber +
                            " " +
                            placeResultData.address_components[i][
                              componentForm[type]
                            ];
          this.removeErrorMessage(
            "streetNumber",
            this.streetNumber
          );
          break;

        case "locality":
          this.city =
                            placeResultData.address_components[i][
                              componentForm[type]
                            ];
          this.removeErrorMessage("city", this.city);
          break;

        case "administrative_area_level_1":
          this.state = {
            value:
                                placeResultData.address_components[i][
                                  componentForm[type]
                                ],
            display:
                                STATES[
                                  placeResultData.address_components[i][
                                    componentForm[type]
                                  ]
                                ]
          };
          this.removeErrorMessage("state", this.state);
          break;

        case "postal_code":
          this.zipCode =
                            placeResultData.address_components[i][
                              componentForm[type]
                            ];
          this.removeErrorMessage("zipCode", this.zipCode);
          break;
        }
      }
      if (types.indexOf("postal_code") < 0) {
        this.zipCode = "";
      }
      this.removeCheckBox();
    },
    addComma(price) {
      return addCommaToNumber(price);
    },
    checkForm(step) {
      let preventSubmit = false;
      this.errorFields = [];
      if (step === 1) {
        if (
          this.policyEffectiveDate === null ||
                    this.policyEffectiveDate === undefined ||
                    this.policyEffectiveDate.length === 0
        ) {
          this.errors["policyEffectiveDate"] =
                        "Policy effective date is required.";
          document
            .getElementsByClassName("form-group-dates")[0]
            .scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          preventSubmit = true;
        } else if (this.beforeCurrentDate) {
          this.errors["policyEffectiveDate"] =
                        "Policy effective date must be current or later date.";
          document
            .getElementsByClassName("form-group-dates")[0]
            .scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          preventSubmit = true;
        }
        if (this.policy_agree.length === 0) {
          this.errors["policy_agree"] =
                        "You must agree to the policy to continue.";
          preventSubmit = true;
        }

        if (!preventSubmit) {
          this.paymentStep++;
        }
      }

      if (step === 2) {
        if (this.payer_is_entity.length) {
          if (this.payerEntityName.trim().length === 0) {
            this.errors["payerEntityName"] =
                            "Name of company is required.";
            this.errorFields.push("payerEntityName");
            preventSubmit = true;
          }
          if (this.payerContactFirstName.trim().length === 0) {
            this.errors["payerContactFirstName"] =
                            "First name is required.";
            this.errorFields.push("payerContactFirstName");
            preventSubmit = true;
          }
          if (this.payerContactLastName.trim().length === 0) {
            this.errors["payerContactLastName"] =
                            "Last name is required.";
            this.errorFields.push("payerContactLastName");
            preventSubmit = true;
          }
        } else {
          if (this.payerFirstName.trim().length === 0) {
            this.errors["payerFirstName"] =
                            "First name is required.";
            this.errorFields.push("payerFirstName");
            preventSubmit = true;
          }
          if (this.payerLastName.trim().length === 0) {
            this.errors["payerLastName"] = "Last name is required.";
            this.errorFields.push("payerLastName");
            preventSubmit = true;
          }
        }
        if (this.payerEmail.trim().length === 0) {
          this.errors["payerEmail"] = "Email is required.";
          this.errorFields.push("payerEmail");
          preventSubmit = true;
        } else if (!this.emailValidator.test(this.payerEmail.trim())) {
          this.errors["payerEmail"] =
                        "Please use a valid email address.";
          this.errorFields.push("payerEmail");
          preventSubmit = true;
        }
        if (this.payerPhone.trim().length !== 12) {
          this.errors["payerPhone"] =
                        "Please enter a valid 10-digit phone number.";
          this.errorFields.push("payerPhone");
          preventSubmit = true;
        }
        if (this.streetNumber.trim().length === 0) {
          this.errors["streetNumber"] = "Street address is required.";
          this.errorFields.push("streetNumber");
          preventSubmit = true;
        }
        if (this.city.trim().length === 0) {
          this.errors["city"] = "City is required.";
          this.errorFields.push("city");
          preventSubmit = true;
        }
        if (this.state === null || this.state === undefined) {
          this.errors["state"] = "State is required.";
          this.errorFields.push("state");
          preventSubmit = true;
        }
        if (this.zipCode.trim().length === 0) {
          this.errors["zipCode"] = "Zip code is required.";
          this.errorFields.push("zipCode");
          preventSubmit = true;
        }

        if (this.errorFields.length > 0)
          document
            .getElementById(this.errorFields[0])
            .scrollIntoView({
              behavior: "smooth",
              block: "center"
            });

        if (!preventSubmit) {
          this.paymentStep++;
          this.next();
        }
      }

      if (step === 3) {
        if (this.bankName.trim().length === 0) {
          this.errors["bankName"] = "Bank name is required.";
          this.errorFields.push("bankName");
          preventSubmit = true;
        }
        if (this.bankRoutingNumber.trim().length !== 9) {
          this.errors["bankRoutingNumber"] =
                        "Please enter a valid 9-digit bank routing number.";
          this.errorFields.push("bankRoutingNumber");
          preventSubmit = true;
        }
        if (this.bankAccountNumber.trim().length === 0) {
          this.errors["bankAccountNumber"] =
                        "Bank account number is required.";
          this.errorFields.push("bankAccountNumber");
          preventSubmit = true;
        }
        if (
          this.bankAccountNumber.trim().length !== 0 &&
                    this.confirmBankAccountNumber.trim().length === 0
        ) {
          this.errors["confirmBankAccountNumber"] =
                        "Bank account number confirmation is required.";
          this.errorFields.push("confirmBankAccountNumber");
          preventSubmit = true;
        } else if (
          this.confirmBankAccountNumber !== this.bankAccountNumber
        ) {
          this.errors["confirmBankAccountNumber"] =
                        "Bank account numbers should match.";
          this.errorFields.push("confirmBankAccountNumber");
          preventSubmit = true;
        }
        if (Object.keys(this.accountType).length === 0) {
          this.errors["accountType"] = "Type of account is required.";
          this.errorFields.push("Checking");
          preventSubmit = true;
        }
        if (
          this.paymentTerms === null ||
                    this.paymentTerms === undefined
        ) {
          this.errors["paymentTerms"] = "Payment term is required.";
          preventSubmit = true;
        }
        if (this.paymentTerms.value === "monthly") {
          if (Object.keys(this.paymentWithdraw).length === 0) {
            this.errors["paymentWithdraw"] =
                            "Withdrawal date is required.";
            this.errorFields.push("1");
            preventSubmit = true;
          }
        }
        if (this.esignature_agree.length === 0) {
          this.errors["esignature_agree"] =
                        "You must agree to use esignature to continue.";
          this.errorFields.push("esignature_agree");
          preventSubmit = true;
        }
        if (this.esignature_agree.length === 1) {
          if (this.signature.trim().length === 0) {
            this.errors["signature"] = "Signature is required.";
            this.errorFields.push("signature");
            preventSubmit = true;
          }
        }
        if (this.errorFields.length > 0)
          document
            .getElementById(this.errorFields[0])
            .scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
        if (!preventSubmit) {
          this.loading = true;
          if (process.env.MIX_APP_ENV === "production") {
            this.recaptcha();
          } else {
            this.$emit("set-score", 1);
            this.submitFormattedProperty();
            this.$emit("finalize");
          }
        }
      }
    },
    handleAccountTypeChange($event) {
      this.accountType = $event;
      this.removeErrorMessage("accountType", $event);
      this.errors["accountType"] = "";
    },
    handlePaymentChange($event) {
      this.paymentTerms = $event;
      this.removeErrorMessage("paymentTerms", $event);
      this.errors["paymentWithdraw"] = "";
    },
    handlePolicyAgreeChange($event) {
      if (this.policy_agree.length) {
        this.policy_agree.pop($event.value);
      } else {
        this.policy_agree.push($event.value);
      }
      this.removeErrorMessage("policy_agree", $event);
    },
    handleEsignatureAgreeChange($event) {
      if (this.esignature_agree.length) {
        this.esignature_agree.pop($event.value);
      } else {
        this.esignature_agree.push($event.value);
      }
      this.removeErrorMessage("esignature_agree", $event);
      this.errors["signature"] = "";
    },
    handlePayerOwnerChange($event) {
      if (this.payer_same_as_owner.length) {
        this.payer_same_as_owner.pop($event.value);
        this.payer_is_entity = [];
      } else {
        this.payer_same_as_owner.push($event.value);
        if (this.propertyOwner.isCommercial === 1) {
          this.payer_is_entity = ["payer_is_entity"];
        } else {
          this.payer_is_entity = [];
        }
      }
      this.handleSamePropertyOwner();
    },
    handleSamePropertyOwner() {
      if (this.payer_same_as_owner.length) {
        const {
          firstName,
          lastName,
          entityName,
          contactFirstName,
          contactLastName,
          email,
          phone,
          street,
          unitNumber,
          city,
          state,
          zip
        } = this.propertyOwner;
        if (this.propertyOwner.isCommercial === 1) {
          this.payerEntityName = entityName;
          this.payerContactFirstName = contactFirstName;
          this.payerContactLastName = contactLastName;
          this.payer_is_entity = ["payer_is_entity"];
        } else {
          this.payerFirstName = firstName;
          this.payerLastName = lastName;
        }
        this.payerEmail = email;
        this.payerPhone = phone;
        this.streetNumber = street;
        this.unitNumber = unitNumber;
        this.city = city;
        this.zipCode = zip;
        if (state) {
          this.state = {
            value: state,
            display: STATES[state]
          };
        }
        this.errors["payerEntityName"] = "";
        this.errors["payerFirstName"] = "";
        this.errors["payerLastName"] = "";
        this.errors["payerContactFirstName"] = "";
        this.errors["payerContactLastName"] = "";
        this.errors["payerEmail"] = "";
        this.errors["payerPhone"] = "";
        this.errors["streetNumber"] = "";
        this.errors["city"] = "";
        this.errors["state"] = "";
        this.errors["zipCode"] = "";
      } else {
        this.payerFirstName = "";
        this.payerLastName = "";
        this.payerEntityName = "";
        this.payerContactFirstName = "";
        this.payerContactLastName = "";
        this.payerEmail = "";
        this.payerPhone = "";
        this.streetNumber = "";
        this.unitNumber = "";
        this.city = "";
        this.state = null;
        this.zipCode = "";
      }
    },
    handlePayerEntityChange($event) {
      if (this.payer_is_entity.length) {
        this.payer_is_entity.pop($event.value);
      } else {
        this.payer_is_entity.push($event.value);
      }
    },
    handleWithdrawOptionChange($event) {
      this.paymentWithdraw = $event;
      this.removeErrorMessage("paymentWithdraw", $event);
    },
    handleStateChange($event) {
      if ($event) {
        // this.errors["state"] = "";
      }
      this.state = $event;
      this.removeCheckBox();
    },
    removeErrorMessage(field, $event) {
      if (field === "paymentTerms" && $event) {
        this.errors[field] = "";
      } else if (field === "accountType" && $event) {
        this.errors[field] = "";
      } else if (field === "paymentWithdraw" && $event) {
        this.errors[field] = "";
      } else if (field === "policy_agree" && $event) {
        this.errors[field] = "";
      } else if (field === "esignature_agree" && $event) {
        this.errors[field] = "";
      } else if (field === "state" && $event) {
        this.errors[field] = "";
      } else if ($event.trim().length) {
        this.errors[field] = "";
      }
    },
    removeCheckBox() {
      if (this.payer_same_as_owner.length) {
        this.payer_same_as_owner.pop();
      }
    },
    setFieldHidden() {
      this.confirmBankAccountFocus = true;
    },
    setFieldVisible() {
      this.confirmBankAccountFocus = false;
    },
    propertiesValues(value) {
      this.properties.forEach(property => {
        value += parseFloat(property.value);
      });
      return value;
    },
    currentDate() {
      let today = new Date();
      this.dateToday = today;
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) dd = `0${dd}`;
      if (mm < 10) mm = `0${mm}`;

      today = `${yyyy}-${mm}-${dd}`;
      this.policyEffectiveDate = today;
    },
    effectiveDateChange($event) {
      if ($event) {
        this.errors.policyEffectiveDate = "";
      }
    },
    formatLienAddress(item) {
      return formatAddress(
        item.street,
        item.unitNumber,
        item.city,
        item.state,
        item.zip,
        "USA"
      );
    },
    prevPaymentStep() {
      if (this.paymentStep === 3) {
        this.confirmBankAccountNumber = "";
        this.esignature_agree = [];
        this.signature = "";
      }
      this.paymentStep--;
    },
    isBankRoutingFocused() {
      let newBankRoutingNumber = this.bankRoutingNumber.split("");
      if (
        newBankRoutingNumber.length < 9 &&
                newBankRoutingNumber.length > 0
      ) {
        this.errors["bankRoutingNumber"] =
                    "Please enter a valid 9-digit bank routing number.";
      }
    },
    round(price) {
      return Math.round(price);
    }
  },
  computed: {
    ...mapState({
      naicCodes: state => state.equipment.naicCodes
    }),
    totalPayable() {
      let premium = 0;
      if (this.payment.availTria === 1) {
        premium = this.triaItem.triaCoverage.row_val
          ? this.triaItem.triaPremium
          : 0;
      }
      return parseFloat(this.totalYearlyPremium) +
        parseFloat(premium);
    },
    annualPremium() {
      return this.addComma(
        this.payment.yearlyPremium + this.payment.triaPremium
      );
    },
    totalDeductible() {
      return this.addComma(this.payment.deductible);
    },
    totalYearlyPremium() {
      return this.addComma(this.payment.yearlyPremium);
    },
    paymentTermOptions() {
      const monthly = this.addComma((this.totalPayable / 12).toFixed(2));
      return [
        {
          value: "monthly",
          row_val: 2,
          display:
                        "Pay monthly" +
                        (this.propertyValueOverLimit
                          ? ""
                          : " $" + monthly + "*")
        },
        {
          value: "full",
          row_val: 1,
          display:
                        "Pay in full" +
                        (this.propertyValueOverLimit
                          ? ""
                          : " $" + Math.round(this.annualPremium))
        }
      ];
    },
    availTria() {
      let availTria = false;
      if (this.triaItem) {
        this.triaItem.triaCoverage.value === "terrorismCoverage_yes"
          ? (availTria = true)
          : (availTria = false);
      }
      return availTria;
    },
    totalPropertiesValue() {
      let value = 0;
      if (this.properties.length) {
        value = this.propertiesValues(value);
      }
      return this.addComma(value);
    },
    beforeCurrentDate() {
      let GivenDate = this.policyEffectiveDate;
      let dateArray = GivenDate.split("-");
      let year = dateArray[0];
      let month = parseInt(dateArray[1], 10) - 1;
      let day = dateArray[2];
      let CurrentDate = new Date();
      GivenDate = new Date(year, month, day);
      GivenDate.setHours(0, 0, 0, 0);
      CurrentDate.setHours(0, 0, 0, 0);
      if (GivenDate < CurrentDate) {
        return true;
      } else {
        return false;
      }
    },
    policyExpirationDate() {
      let dateArray = this.policyEffectiveDate.split("-");
      let year = dateArray[0];
      let expiredYear = parseInt(dateArray[0]) + 1;
      let month = parseInt(dateArray[1], 10) - 1;
      let day = parseInt(dateArray[2], 10);
      let expirationDate = new Date(year, month, day);
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];

      expirationDate = monthNames[`${month}`] + ` ${day}, ${expiredYear}`;
      return expirationDate;
    },
    computeTotalPropValue() {
      let value = 0;
      if (this.properties.length) {
        value = this.propertiesValues(value);
      }
      return value.toFixed(2);
    },
    propertyValueOverLimit() {
      return this.computeTotalPropValue > 100000 ? true : false;
    },
    policyAgreeOptions() {
      return [
        {
          value: "policy_agree",
          row_val: "policy_agree",
          display:
                        "I have reviewed the contents of this application, along with the fraud statement above, and I declare to the best of my knowledge that all statements herein are true and no material facts have been suppressed or misstated. Additionally, I agree to use electronic records and signatures."
        }
      ];
    },
    esignatureAgreeOptions() {
      return [
        {
          value: "esignature_agree",
          row_val: "esignature_agree",
          display:
                        "I have read and agree to the terms and conditions stated above, and I agree to use electronic records and signatures."
        }
      ];
    },
    accountTypeOption() {
      return [
        {
          value: "Checking",
          display: "Checking"
        },
        {
          value: "Savings",
          display: "Savings"
        }
      ];
    },
    paymentWithdrawOption() {
      return [
        {
          value: 1,
          row_val: 1,
          display: "1st of the month"
        },
        {
          value: 15,
          row_val: 0,
          display: "15th of the month"
        }
      ];
    },
    payerSameAsOwnerOptions() {
      return [
        {
          value: "payer_same_as_owner",
          row_val: "payer_same_as_owner",
          display: "Same as property owner"
        }
      ];
    },
    payerEntityOptions() {
      return [
        {
          value: "payer_is_entity",
          row_val: "payer_is_entity",
          display: "Buyer is a company"
        }
      ];
    },
    states() {
      let states = Object.keys(STATES).map(s => {
        return {
          value: s,
          display: STATES[s]
        };
      });
      return states;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.button-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    button svg {
        margin-right: 1rem;
    }
    button:last-of-type {
        margin-left: $padding-lg;
    }
}
.expiration-date {
    width: 49%;
    font-size: $font-size-sm;

    color: $label-gray;
    margin: $padding-lg 0;
    @media (max-width: $mobile-hd-width) {
        width: 100%;
        margin: 0.5rem 0 1rem;
    }
}
.error {
    position: relative;
    padding: 0 $padding-input-left;
    margin-top: $padding-xs;
    font-family: $system-font;
    font-size: $font-size-sm;
    color: $red-active;
}
.el-date-editor {
    height: 100%;
    input {
        font-size: $font-size-sm;
    }
}
.underwriter-text {
    margin: 0 0 1rem;
    background-color: $background-gray;
    padding: $padding-wrapper-sm;
    color: $blue-navy;
    text-align: left;
    font-weight: 400;

    font-size: $font-size-xs;
    span {
        font-weight: bold;
    }
}
.alternate-note {
    font-size: $font-size-xs;
    color: $label-gray;
    &.terms {
        margin: 0 0 2rem;
    }
}
.checkbox-group {
    margin-bottom: 1.25rem;
    .checkbox {
        margin-bottom: 0;
        .checkbox__label {
            margin: 0;
        }
    }
}
</style>
